/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Gu7Inputs */

const en__field_enum_icsrm_gu7 = /** @type {(inputs: _Field_Enum_Icsrm_Gu7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goethe University Frankfurt`)
};

const de__field_enum_icsrm_gu7 = /** @type {(inputs: _Field_Enum_Icsrm_Gu7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goethe-Universität Frankfurt`)
};

/**
* | output |
* | --- |
* | "Goethe University Frankfurt" |
*
* @param {_Field_Enum_Icsrm_Gu7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_gu7 = /** @type {((inputs?: _Field_Enum_Icsrm_Gu7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Gu7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_gu7(inputs)
	return de__field_enum_icsrm_gu7(inputs)
});
export { _field_enum_icsrm_gu7 as "_field_enum_ICSRM_GU" }